<template>
  <div class="h5-form-body">
    <span class="h5-form-title">{{payResultBean.result_game_name}}游戏充值结果</span>
    <p class="h5-form-p">
      <span class="h5-form-label">充值账户:</span>
      <span class="h5-form-span">{{payResultBean.result_account}}</span>
    </p>
    <p class="h5-form-p">
      <span class="h5-form-label">游戏名称:</span>
      <span class="h5-form-span">{{payResultBean.result_game_name}}</span>
    </p>
    <p class="h5-form-p">
      <span class="h5-form-label">游戏区服:</span>
      <span class="h5-form-span">{{payResultBean.result_server_name}}</span>
    </p>
    <p class="h5-form-p">
      <span class="h5-form-label">金额:</span>
      <span class="h5-form-span" style="color: #ff0000;">{{payResultBean.result_money}}元</span>
    </p>
    <p class="h5-form-p">
      <span class="h5-form-label">游戏金额:</span>
      <span class="h5-form-span">{{payResultBean.result_gold}}虚拟币</span>
    </p>
    <p class="h5-form-p">
      <span class="h5-form-label">充值时间:</span>
      <span class="h5-form-span" v-if="payResultBean.result_end_time != 0">{{payResultBean.result_end_time| dateFormat}}</span>
      <span class="h5-form-span" v-if="payResultBean.result_end_time == 0">---</span>
    </p>
    <p class="h5-form-p">
      <span class="h5-form-label">充值结果:</span>
      <span class="h5-form-span" v-if="payResultBean.result_state == 1" style="color: #00FF00;">充值成功</span>
      <span class="h5-form-span" v-if="payResultBean.result_state == 2" style="color: #ff0000;">充值失败</span>
      <span class="h5-form-span" v-if="payResultBean.result_state == 0" style="color: #ccc;">未支付</span>
    </p>
    <p class="h5-close" @click="closePage">退出</p>
  </div>
</template>

<script>
  import JSEncrypt from 'jsencrypt'
export default {
  metaInfo(){
    return {
      title:"支付结果_"+this.$store.state.home.title,
      meta:[
        { name:'keywords', content:this.$store.state.home.keywords},
        { name:'description',content:this.$store.state.home.description}
      ]
    }
  },
  asyncData({store,route}){
    return store.dispatch('initSeo',{store:store});
  },
  methods: {
    queryPayResult(){
      this.$http.post(`/set_pay_result?order_oid=`+this.order_oid+"&pay_type="+this.order_type,{})
      .then(res=>{
        if(res.data.code == 1050 || res.data.code == 1085){
          
        }else if(res.data.code == 1088){
          this.payResultBean.result_end_time = 0;
          this.payResultBean.result_state = 0;
        }
        this.payResultBean = res.data.data;
      })
    },
    closePage(){
      window.opener = null;
      window.open("about:blank","_top").close();
    }
  },
  data() {
    return {
      order_oid:"",
      order_type:"",
      payResultBean:{
        result_account:"",
        result_game_name:"",
        result_server_name:"",
        result_state:0,
        result_money:"",
        result_gold:"",
        result_end_time:0
      },
    };
  },
  mounted(){ 
    this.order_oid = this.$route.query.order_oid;
    this.order_type = this.$route.query.order_type;
    if(this.order_oid != null){
      this.queryPayResult();
    }
  },
};
</script>
<style>
 .h5-form-body{
   padding: 10px;
 }
 .h5-form-title{
   line-height: 30px;
   height: 30px;
   display: inline-block;
   width: 100%;
   text-align: center;
   font-weight: bold;
   font-size: 20px;
   color: black;
 }
 .h5-form-p{
   font-size: 18px;
   height: 30px;
   line-height: 30px;
   margin: 7px 10px;
 }
 .h5-form-label{
   display: inline-block;
   width: 35%;
   float: left;
 }
 .h5-form-span{
   float: right;
   color: black;
 }
 .h5-close{
   text-align: center;
   font-size: 15px;
   font-weight: bold;
   height: 45px;
   line-height: 45px;
   cursor: pointer;
 }
</style>

